import GenerateAPI from '../generate.js'
import Utils from '@/utils/util'
let wConfig = Utils.getConfig()
const config = {
    list: {
        url: '/client/record/feelist',
        apiType: 'check',
    },
    detail: {
        url: '/client/record/feelist/detail',
        apiType: 'check',
    },
    ticket: {
        url: '/client/record/feelist/ticket',
        apiType: 'check',
    },
    download: {
        url: '/ticket/open/getTicketImg',
        baseURL: wConfig.VUE_APP_BILL_API
    },
}
const apiPaySituation = GenerateAPI.generate(config)

export default {
    ...apiPaySituation,
    getTicketImgUrl: (ticketCode, ticketNum) => {
        let url = wConfig.VUE_APP_BILL_API + '/openapi/ticket/download/'
        if (ticketCode && ticketCode !== 'undefined') {
            url += ticketCode + '/' + ticketNum
        } else {
            // 数电是没有ticketCode的，在这里默认为electric，以统一下载地址
            url += 'electric' + '/' + ticketNum
        }
        return url
    }
}

